import React from 'react';
import { Image, View } from 'react-native';
import {
  icon_gallery,
  img_black_cat, img_cake, img_pizza, img_tree_with_sky,
} from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const TopImageBar = ({ marginBottom = 30 }) => {
  const myStyles = {
    container:
            {
              paddingHorizontal: '5%',
              width: '97%',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              marginBottom,
            },
    imageStyle: {
      width: 45,
      height: 45,
    },
    imagePizzaStyle: {
      height: 45,
      width: 45,
      position: 'absolute',
      marginLeft: '97%',
    },
  };
  return (
    <View>
      <View style={myStyles.container}>
        <Image
          fadeDuration={0}
          style={myStyles.imageStyle}
          source={icon_gallery}
        />
        <Image
          fadeDuration={0}
          style={myStyles.imageStyle}
          source={img_cake}
        />
        <Image
          fadeDuration={0}
          style={myStyles.imageStyle}
          source={img_tree_with_sky}
        />
        <Image
          fadeDuration={0}
          style={myStyles.imageStyle}
          source={img_black_cat}
        />
      </View>
      <Image
        fadeDuration={0}
        style={myStyles.imagePizzaStyle}
        source={img_pizza}
      />
    </View>
  );
};
export default TopImageBar;
